var _style, _ellipse, _polygon, _polygon2, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _g3, _g4, _g5, _polygon3, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiquinNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0{fill:#ECECEC;}\r\n\t\t.st1{fill:#FBAC00;}\r\n\t\t.st2{fill:url(#Brazo_derecho_00000053531758791329196840000008219614339194781573_);}\r\n\t\t.st3{fill:url(#SVGID_1_);}\r\n\t\t.st4{fill:url(#Brazo_Izquierdo_00000026869849792187682560000011748790527684981641_);}\r\n\t\t.st5{fill:url(#SVGID_00000089548197013827444960000001168234216357315981_);}\r\n\t\t.st6{fill:url(#pie_izquierdo_00000001654257878691051340000013660631560558070942_);}\r\n\t\t.st7{fill:url(#pie_derecho_00000162354648207044632920000002277307176499020173_);}\r\n\t\t.st8{fill:#D6E0EE;}\r\n\t\t.st9{opacity:0.15;fill:#FFFFFF;enable-background:new    ;}\r\n\t\t.st10{opacity:0.95;fill:#476493;enable-background:new    ;}\r\n\t\t.st11{fill:url(#SVGID_00000098933860068625632680000017384976803436854432_);}\r\n\t\t.st12{fill:#FFFFFF;}\r\n\t\t.st13{fill:#039BD7;}\r\n\t\t.st14{fill:url(#Antena_00000174580917871174036050000011870316189914416813_);}\r\n\t\t.st15{fill:url(#SVGID_00000075159340740802611230000018109735168964371597_);}\r\n\t\t.st16{fill:#476493;}\r\n\t\t.st17{fill:url(#SVGID_00000179603812485163240040000010004566146584754323_);}\r\n\t\t.st18{opacity:0.9;fill:#F3F9FD;enable-background:new    ;}\r\n\t\t.st19{fill:#FFB412;}\r\n\t\t.st20{fill:#4D4D4D;}\r\n\t\t.st21{opacity:0.5;}\r\n\t\t.st22{opacity:0.5;fill:#5FA3AA;enable-background:new    ;}\r\n\t\t.st23{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t\t.st24{fill:#333333;}\r\n\t\t.st25{fill:#112129;}\r\n\t\t.st26{fill:#FFC800;}\r\n\t\t.st27{fill:#1A2E35;}\r\n\t")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 250,
    cy: 473.6,
    rx: 250,
    ry: 26.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "137.8,488.2 413.8,488.2 373.9,302.8 97.9,302.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "302,283.6 370.7,283.6 373.9,302.8 300.3,302.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Robot"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Brazo_derecho_00000027602811099653964850000017879589474256099742_",
    gradientUnits: "userSpaceOnUse",
    x1: -185.1723,
    y1: -773.8083,
    x2: -151.1852,
    y2: -712.9656,
    gradientTransform: "matrix(0.2461 -1.0413 -1.2681 -0.2429 -593.253 -126.4819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6E0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC8D5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Brazo_derecho",
    style: {
      fill: "url(#Brazo_derecho_00000027602811099653964850000017879589474256099742_)"
    },
    d: " M278.4,266.8c0.7,2.5,1.7,5.9,5,7.6c8,4.1,22.8-6.1,28.6-9.4c32.5-17.9,53.1-49.3,40.7-65.4c-2-2.7-7-7.2-14.4-9.3 c-9.2-2.6-17.5,0-19.2,0.5c-14.1,4.4-12.7,14.2-34.6,50.1C281.3,246.4,275.3,255.9,278.4,266.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -469.5896,
    y1: -273.0654,
    x2: -448.9924,
    y2: -273.0654,
    gradientTransform: "matrix(0.9846 0.1748 -0.1748 0.9846 743.7635 571.8901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFC8D5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#C3CBD8",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#CFD6E0",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#DBE0E7",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E4E8ED",
      stopOpacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#ECEFF3",
      stopOpacity: 0.72
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#F3F5F7",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F9FA",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#FCFCFD",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#FEFEFE",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.1,233.3c0.1,0.1,0.2,0.1,0.2,0.1c0.2,0,0.4,0,0.5-0.2c0.2-0.2,0.1-0.5-0.1-0.7 c-3.6-3-6.9-6.2-9.8-9.7s-5-7-6.4-10.4c-0.1-0.3-0.4-0.4-0.6-0.3c-0.3,0.1-0.4,0.4-0.3,0.6c1.4,3.6,3.6,7.1,6.5,10.7 C340.1,227,343.4,230.3,347.1,233.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Brazo_Izquierdo_00000034071523461455208350000009751087974215623834_",
    gradientUnits: "userSpaceOnUse",
    x1: -308.4428,
    y1: 147.7723,
    x2: -276.4711,
    y2: 196.3112,
    gradientTransform: "matrix(-0.2585 1.0383 1.2652 0.258 -120.3469 558.0479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6E0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#CBD7E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#B5C4CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADBDC6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Brazo_Izquierdo",
    style: {
      fill: "url(#Brazo_Izquierdo_00000034071523461455208350000009751087974215623834_)"
    },
    d: " M197.6,287.4c-22.3,35.7-21,45.4-35.1,49.7c-1.6,0.5-10,3-19.2,0.3c-7.3-2.2-12.3-6.8-14.3-9.4 c-12.2-16.3,8.8-47.4,41.5-64.9c5.9-3.1,20.7-13.2,28.7-9c3.3,1.7,4.2,5.2,4.9,7.6C207.1,272.5,201,282,197.6,287.4 L197.6,287.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178188877386716352090000010412485728292327309_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.4214,
    y1: -156.2142,
    x2: 275.0219,
    y2: -156.2142,
    gradientTransform: "matrix(0.9825 0.1865 0.1865 -0.9825 -87.8377 102.2084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#FEFEFE",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#FCFCFD",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#F8F9FA",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#F3F5F7",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#ECEFF3",
      stopOpacity: 0.72
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#E4E8ED",
      stopOpacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#DBE0E7",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#CFD6E0",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#C3CBD8",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC8D5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178188877386716352090000010412485728292327309_)"
    },
    d: "M135.4,294.4c3.6,3,6.9,6.4,9.8,10 c2.9,3.6,5,7.2,6.4,10.8c0.1,0.3,0,0.5-0.3,0.6s-0.5,0-0.6-0.3c-1.3-3.5-3.4-7-6.2-10.5c-2.9-3.5-6.1-6.8-9.7-9.8 c-0.2-0.2-0.2-0.5-0.1-0.7c0.1-0.1,0.3-0.2,0.5-0.2C135.3,294.3,135.4,294.3,135.4,294.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pie_izquierdo_00000096052736994596192620000001748646228574022063_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.2,
    y1: -423.8333,
    x2: 204.2,
    y2: -468.9826,
    gradientTransform: "matrix(1 0 0 -1 0 -79.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1490C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191C38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "pie_izquierdo",
    style: {
      fill: "url(#pie_izquierdo_00000096052736994596192620000001748646228574022063_)"
    },
    d: " M233.5,371.4l0.1,8.1c0,0-0.3,9.8-28.4,10.1c0,0-26.7,0.1-29.8-9.1c0,0-0.6-4.6-0.6-10.3c0-5.7,0.2-21.1,1.1-25.7 c0,0,7.2,1.9,21.4,12.3c0,0,11.9,8.9,12.5,9.3s5.6,4.6,16.2,5.5C226,371.6,232.6,371.7,233.5,371.4L233.5,371.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pie_derecho_00000179614820178893365100000001622219934366065292_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.5623,
    y1: -423.6,
    x2: 277.5623,
    y2: -469.0348,
    gradientTransform: "matrix(1 0 0 -1 0 -79.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1490C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191C38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "pie_derecho",
    style: {
      fill: "url(#pie_derecho_00000179614820178893365100000001622219934366065292_)"
    },
    d: "M306.5,344.2 c0,0,2.1,22.9,0.8,35c0,0,1,6.2-15.3,9.1c0,0-27.5,5-40.5-3.7c0,0-3.3-1.6-4.1-5l0.1-8.1c0,0,9.3,1.2,15.9-1.3 c0,0,6.1-2,12.6-6.8c0,0,10.9-8.5,16.2-11.6C292,351.7,302.7,345.3,306.5,344.2L306.5,344.2z"
  }), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Cuerpo",
    className: "st8",
    d: "M202.3,250.5c5.7-4.9,12.7-8.1,15.2-8.9c9-3.2,17-2.6,22.3-2.7h0.9c5.3,0,13.3-0.5,22.3,2.7 c2.5,0.9,10.6,3,15.2,8.9c18.5,24.5,27.8,91.9,27.8,91.9c-30.8,14.9-37.6,30.6-58.6,26.9l-0.1-21.3h-13.8v21.3 c-25.3,2.4-26.9-15.7-57-26.9C176.4,342.4,183.8,266.2,202.3,250.5L202.3,250.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Circulo"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M267.2,280.1c3,19.1-12.4,35.3-30.5,32.2c-10.9-1.9-19.8-11.2-21.6-22.7c-3-19.1,12.4-35.3,30.5-32.2 C256.6,259.3,265.4,268.6,267.2,280.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M267.2,281.2c3,18.4-12.4,34.1-30.5,31.1c-10.9-1.8-19.8-10.8-21.6-22c-3-18.4,12.4-34.1,30.5-31.1 C256.6,261,265.4,270,267.2,281.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153664830622001826430000010891447480302591923_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.15,
    y1: -339.9431,
    x2: 241.15,
    y2: -392.0569,
    gradientTransform: "matrix(1 0 0 -1 0 -79.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#039BD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#077FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#0D608F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#11476F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#153357"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#182545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#191C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153664830622001826430000010891447480302591923_)"
    },
    d: "M267.2,282.2 c3,17.8-12.4,33-30.5,30.1c-10.9-1.8-19.8-10.5-21.6-21.3c-3-17.8,12.4-33,30.5-30.1C256.6,262.7,265.4,271.4,267.2,282.2z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 240.9,
    cy: 285.9,
    rx: 18.7,
    ry: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M241.1,298.1l-12.4-18.6l12.4,10.8l15-15.3c-3.4-4.7-8.9-7.8-15.1-7.8c-10.3,0-18.7,8.4-18.7,18.8 s8.4,18.8,18.7,18.8s18.7-8.4,18.7-18.8c0-3.3-0.9-6.5-2.4-9.2L241.1,298.1L241.1,298.1z M241.1,274.9c2.4,0,4.3,2,4.3,4.4 s-1.9,4.4-4.3,4.4s-4.3-2-4.3-4.4S238.7,274.9,241.1,274.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M266.9,263.8L256.1,275c0.4,0.6,0.8,1.2,1.1,1.8L266.9,263.8z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.6,265.1c-0.2,0.1-0.3,0.4-0.2,0.7c0.1,0.2,0.4,0.3,0.7,0.2c14.6-8,29.2-12,43.8-12s29.2,4,43.8,12 c0.2,0.1,0.5,0,0.7-0.2c0.1-0.2,0-0.5-0.2-0.7c-14.7-8.1-29.5-12.1-44.3-12.1S210.4,257,195.6,265.1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Cabeza"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Antena_00000117667317010324393020000018293775003313610664_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.7994,
    y1: -185.6563,
    x2: 173.7994,
    y2: -241.0307,
    gradientTransform: "matrix(0.9987 -5.089957e-02 -5.089957e-02 -0.9987 41.689 -175.3954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#99E9ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    style: {
      stopColor: "#7FCFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5539,
    style: {
      stopColor: "#55A5F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    style: {
      stopColor: "#3B8BFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3181FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Antena",
    style: {
      fill: "url(#Antena_00000117667317010324393020000018293775003313610664_)"
    },
    d: "M246.4,19.5 c0.5,9.2-5,17.1-13.1,20.3l0.8,15.6l-13.7,0.7l-0.8-15.6c-8.1-2.5-14.2-9.9-14.6-18.9c-0.6-11.5,8.2-21,19.7-21.6 C236.1-0.6,245.8,8,246.4,19.5L246.4,19.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080919690537807235660000014213723769119108230_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.7999,
    y1: -240.0547,
    x2: 173.7999,
    y2: -433.5136,
    gradientTransform: "matrix(0.9987 -5.089957e-02 -5.089957e-02 -0.9987 41.689 -175.3954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6E0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#CDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFCEE3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080919690537807235660000014213723769119108230_)"
    },
    d: "M227.5,55.5 c-60.6,3.1-107.3,54.7-104.2,115.4l1,20.5c1.8,34.7,31.4,61.5,66.1,59.7l93.8-4.8c34.7-1.8,61.5-31.4,59.7-66.1l-1-20.5 C339.8,99.1,288.1,52.4,227.5,55.5L227.5,55.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.5,190.3c1.1,21.5,19.4,38,40.9,36.9l103.4-5.3c21.5-1.1,38-19.4,36.9-40.9l-1.4-28.1 c-1.5-29.5-26.7-52.2-56.2-50.7l-74.3,3.8c-29.5,1.5-52.2,26.7-50.7,56.2L143.5,190.3L143.5,190.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M142.2,164.4c-1.5-29.7,21.3-55,51-56.5l73.7-3.8c29.7-1.5,55,21.3,56.5,51l1.4,27.5 c1.1,21.6-15.5,40.1-37.2,41.2L184.8,229c-21.6,1.1-40.1-15.5-41.2-37.2L142.2,164.4L142.2,164.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126294191059946865950000017105582284096631438_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.7735,
    y1: -297.5038,
    x2: 173.7735,
    y2: -411.3961,
    gradientTransform: "matrix(0.9987 -5.089957e-02 -5.089957e-02 -0.9987 41.689 -175.3954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E3D86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#102C43"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126294191059946865950000017105582284096631438_)"
    },
    d: "M142.5,171.3 c-1.5-29.7,21.3-55,51-56.5l73.7-3.8c29.7-1.5,55,21.3,56.5,51l1.1,20.8c1.1,21.6-15.5,40.1-37.2,41.2l-102.8,5.2 c-21.6,1.1-40.1-15.5-41.2-37.2L142.5,171.3L142.5,171.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M275.3,143.6l2.6-0.1c5.7-0.3,10.6,4.1,10.9,9.8l1.1,22.5c0.3,5.7-4.1,10.6-9.8,10.9l-2.6,0.1 c-5.7,0.3-10.6-4.1-10.9-9.8l-1.1-22.5C265.2,148.8,269.6,143.9,275.3,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M214.2,165.3c0.3,1.7-1.1,3.2-2.8,3.1c-5.5-0.2-13-0.1-21.9,1.2c-5.1,0.8-12.7,2.3-21.2,5.3 c-1.6,0.6-3.4-0.4-3.6-2.2l0,0c-0.2-1.3,0.5-2.5,1.7-3c5.2-1.9,12.7-4.2,21.9-5.7c9.6-1.5,17.6-1.5,23.3-1.2 C212.9,163,214,164,214.2,165.3L214.2,165.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M286.4,224L286.4,224c0.9,7.4,1,12.8,0.3,16.3l-0.3,1.2c-0.4,1.8-0.7,3.1-1,4l-0.3,0.7l1.1-0.1l0.1-0.4 c0.3-1,0.7-2.3,1.1-4.1l0.3-1.2c0.8-3.7,0.7-8.9-0.3-16.5L286.4,224L286.4,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.9,229.1C185.9,229.1,185.9,229.2,185.9,229.1c-0.2,7.5,0.3,12.8,1.4,16.2l0.4,1.2 c0.5,1.7,1,3,1.4,3.9l0.3,0.7h-1.1l-0.2-0.3c-0.4-0.9-0.9-2.3-1.5-4l-0.4-1.2c-1.1-3.6-1.6-8.8-1.4-16.5 C184.9,229.2,185.9,229.1,185.9,229.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M199.8,60.5c-23.6,16.9-20.9,47.8-20.9,48.1l0,0l1-0.3c-0.2-2.6-1.9-33.5,23.2-48.9l-1.4,0.4 L199.8,60.5L199.8,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M255.4,57.7c25.2,14.4,25.6,45.4,25.6,45.7l0,0l-1.1-0.2c-0.1-2.6-1.6-33.5-28.1-46.2l1.5,0.3 L255.4,57.7L255.4,57.7z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M322.4,82.9l-0.5,0.2l-0.3-0.5c-0.9-1.7-1.7-3.2-2.4-4.6c-3.2-6.1-4.6-8.6-3.7-12.3c0.9-3.9,3-6.9,5-9.7 c2.1-3,4.3-6.2,5.1-10.4c0.7-4.1-0.7-7.8-3.7-9.7c-3.6-2.3-8.6-1.5-13.4,2.1c-2.9,2.1-4.6,3.9-5.8,5.2 c-3.7,3.9-4.2,3.5-12.6-3.1c-0.9-0.7-1.8-1.4-2.9-2.2l-0.5-0.4L287,37c7.9-13.4,20.6-21.2,34.1-20.8c9.8,0.3,18,4.9,21.9,12.4 c4.4,8.5,2.7,19.6-4.9,31c-4.9,7.5-3.4,10.8-2.4,13c0.5,1.1,1,2.1,0.5,3.2C335.4,77.8,332,79.5,322.4,82.9z M312.9,34.1 c3.6-1.3,7-1.1,9.8,0.7c3.5,2.2,5.2,6.4,4.3,11c-0.8,4.5-3.1,7.8-5.3,10.9c-2,2.9-4,5.7-4.8,9.3c-0.8,3.3,0.4,5.5,3.6,11.4 c0.6,1.2,1.3,2.5,2.1,4.1c8.4-3,11.9-4.7,12.5-6c0.2-0.5,0-1.1-0.5-2.2c-1.1-2.5-2.8-6.2,2.5-14.3c7.3-11,9-21.6,4.8-29.7 c-3.7-7.1-11.4-11.5-20.8-11.7c-12.8-0.3-24.9,7-32.6,19.6c0.9,0.7,1.7,1.3,2.4,1.9c4,3.1,6.2,4.8,7.6,5.2 c1,0.3,1.6-0.3,3.3-2c1.3-1.3,3-3.2,6-5.4C309.4,35.6,311.2,34.7,312.9,34.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M337.6,106.8c-4.9,1.7-11.4,0.5-13.8-6.4c-2.4-6.8,1.8-11.8,6.7-13.6c5.1-1.8,11.5-0.2,13.8,6.3 C346.7,99.8,342.8,105,337.6,106.8z M331,88.2c-4.3,1.5-8,5.9-5.9,11.9s7.8,7.1,12.1,5.6c4.4-1.5,8.1-5.9,6-11.9 C341.1,87.7,335.4,86.6,331,88.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M323.4,85.7l-3,1.1l-1.5-2.9c-0.9-1.7-1.7-3.2-2.4-4.5c-3.4-6.4-5.1-9.6-4-14.4c0-0.1,0.1-0.2,0.1-0.4 l1.3,0.3l-0.1,0.3c-1,4.4,0.6,7.5,3.8,13.5c0.7,1.3,1.5,2.8,2.4,4.5l1,1.8l2-0.7c10.4-3.7,13.7-5.5,14.8-7.9 c0.3-0.7,0.4-1.5,0.3-2.3l1.3-0.2c0.2,1.1,0,2.1-0.4,3C337.7,80,334.4,81.8,323.4,85.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M323.9,41.5l-1.3,0.3c-0.1-0.2-0.1-0.5-0.2-0.7c-0.3-0.9-0.8-1.6-1.5-2.2c-1.8-1.6-4.7-1.6-7.8-0.2 l-0.6-1.2c3.5-1.7,7-1.5,9.2,0.4c0.9,0.7,1.5,1.7,1.9,2.8C323.8,40.9,323.9,41.2,323.9,41.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M300.9,48.4c-3.5,1.2-6-0.7-12.7-5.8c-0.9-0.7-1.8-1.4-2.9-2.2l-2.6-2l1.7-2.8 c3.7-6.3,8.3-11.4,13.7-15.1l0.8,1.1c-5.3,3.7-9.8,8.6-13.4,14.7l-1.1,1.8l1.7,1.3c1.1,0.8,2,1.6,2.9,2.2 c6.4,5,8.6,6.6,11.4,5.6c0.7-0.3,1.4-0.7,2.1-1.3l0.9,1C302.6,47.5,301.8,48,300.9,48.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M346,51l-1.2-0.5c2.7-7.1,3.1-14,1-19.8c-0.5-1.5-1.2-3-2.1-4.3l1.1-0.7c0.9,1.5,1.6,3,2.2,4.6 C349.2,36.4,348.9,43.6,346,51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M338.7,109.7L338.7,109.7c-6.6,2.3-14.7,0.2-17.7-8.2c-0.5-1.6-0.8-3.1-0.9-4.6h1.3 c0,1.4,0.3,2.8,0.8,4.2c2.7,7.6,10.1,9.5,16,7.4L338.7,109.7z M348,98.7l-1.3-0.2c0.2-1.9,0-3.9-0.7-5.9 c-0.9-2.6-2.4-4.7-4.5-6.1l0.7-1.1c2.3,1.6,4,3.9,5,6.7C348.1,94.4,348.3,96.6,348,98.7z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "140.4,296.6 143.3,294.4 149.9,303.3 147,305.4  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_00000075841963118770979090000016484361493033270201_",
    className: "st22",
    cx: 130.5,
    cy: 280.1,
    rx: 18.5,
    ry: 18.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M115.4,280.7c-0.2,0.1-0.4,0.2-0.7,0.2c-0.6,0-1.1-0.5-1.1-1.1c0-1.2,0.2-2.4,0.4-3.5 c0.1-0.6,0.7-1,1.3-0.8c0.6,0.1,1,0.7,0.8,1.3c-0.2,1-0.4,2-0.4,3.1C115.8,280.2,115.6,280.5,115.4,280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M125.9,295.8c-0.3,0.2-0.7,0.3-1,0.2c-3.2-1.1-5.9-3.1-7.9-5.9c-1-1.4-1.8-2.9-2.4-4.5 c-0.2-0.6,0.1-1.2,0.7-1.4c0.6-0.2,1.2,0.1,1.4,0.7c0.5,1.4,1.2,2.7,2.1,3.9c1.7,2.4,4.1,4.1,6.9,5.1c0.6,0.2,0.9,0.8,0.7,1.4 C126.2,295.5,126.1,295.7,125.9,295.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M117,261.9c-10,7.4-12.1,21.6-4.7,31.6s21.6,12.1,31.6,4.7s12.1-21.6,4.7-31.6S127,254.5,117,261.9z  M141.5,294.9c-8.2,6.1-19.8,4.4-25.9-3.8c-6.1-8.2-4.4-19.8,3.8-25.9s19.8-4.4,25.9,3.8C151.4,277.2,149.7,288.8,141.5,294.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "145.7,306.1 150.9,302.3 169.9,327.9 164.7,331.7  "
  })))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "138.2,488.2 414.8,488.2 454.1,309.6 177.5,309.6  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 358.9,
    cy: 403.2,
    r: 12.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 256.6,
    cy: 403.2,
    r: 12.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M289.2,418.2l0.7-1.4c0.1-0.1,6.8-12.5,20.2-12.5c12.3,0,15.3,11.6,15.4,12.1l0.4,1.5l3-0.7l-0.4-1.5 c0-0.1-3.6-14.5-18.4-14.5c-15.3,0-22.6,13.5-22.9,14.1l-0.7,1.4L289.2,418.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiquinNoData);
export default __webpack_public_path__ + "static/media/ethiquin_no_data.04ff6e5d5e2c2dd2bac3767505d30e50.svg";
export { ForwardRef as ReactComponent };